import React from 'react';
import { Globe } from 'lucide-react';
import { LANGUAGES } from '../i18n/languages';
import { useLanguage } from '../context/LanguageContext';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from './ui/dropdown-menu';

export const LanguageSwitcher = ({ persist = false, compact = false, testId = 'language-switcher' }) => {
  const { lang, changeLanguage } = useLanguage();
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid={`${testId}-trigger`}
          aria-label={`Language: ${current.native}`}
          title={`Language: ${current.native}`}
          className="inline-flex min-h-[44px] min-w-[44px] shrink-0 items-center justify-center gap-2 rounded-md border border-border bg-white/60 px-3 py-2 text-sm font-medium text-primary transition-colors hover:border-accent/40"
        >
          <Globe className="h-4 w-4" />
          {!compact && <span className="hidden sm:inline" style={{ fontFamily: current.font }}>{current.native}</span>}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="max-h-[min(24rem,var(--radix-dropdown-menu-content-available-height))] w-56 overflow-y-auto">
        {['Global', 'India'].map((grp) => (
          <div key={grp}>
            <div className="px-2 py-1.5 text-[10px] font-bold uppercase tracking-[0.15em] text-muted-foreground">{grp}</div>
            {LANGUAGES.filter((l) => l.group === grp).map((l) => (
              <DropdownMenuItem
                key={l.code}
                data-testid={testId === 'language-switcher' ? `language-option-${l.code}` : `${testId}-option-${l.code}`}
                onClick={() => changeLanguage(l.code, persist)}
                className={`cursor-pointer ${l.code === lang ? 'bg-muted font-semibold' : ''}`}
              >
                <span className="me-2 w-7 text-xs uppercase tracking-wide text-muted-foreground">{l.code}</span>
                <span style={{ fontFamily: l.font }}>{l.native}</span>
              </DropdownMenuItem>
            ))}
          </div>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
